<div id="itemButton" class="event-item" (click)="cardClickedEvent.next()">
	<!-- left side -->
	<div class="left-side">
		<div class="flex flex-column">
			<div class="title" [attr.data-test]="milestone! | milestoneTypes | lowercase">
				{{ milestone! | milestoneTypes }}
			</div>
			<div class="subtitle" [attr.data-test]="(milestone! | milestoneTypes) + '-date' | lowercase">
				@if(hasTimezoneFeature) {
				<span>{{ milestone!.date | suffixLocalTimezoneDate }} ({{ timeZoneShort }})</span>
				<br /><span class="utc-date">{{ milestone!.date | suffixAndAbbreviatedDate }} (UTC)</span>
				} @else {
				<br /><span>{{ milestone!.date | suffixAndAbbreviatedDate }}</span>
				}
			</div>
		</div>

		@if (hasBookingDate) {
		<span class="booking-border"></span>
		<div class="flex flex-column">
			<div class="title" [attr.data-test]="'net booking'">BOOKING DATE</div>
			<div class="subtitle" [attr.data-test]="'net booking-date'">
				@if(hasTimezoneFeature) {
				<span>{{ milestone!.extraInfo!.netBookingDate | suffixLocalTimezoneDate }} ({{ timeZoneShort }})</span
				><br />
				<span class="utc-date"
					>{{ milestone!.extraInfo!.netBookingDate | suffixAndAbbreviatedDate }} (UTC)</span
				>
				} @else {
				<span>{{ milestone!.extraInfo!.netBookingDate | suffixAndAbbreviatedDate }}</span>
				}
			</div>
		</div>
		}
	</div>

	<!-- Right side -->
	<div class="right-side">
		<!-- Details CTA -->
		<div
			class="details-cta"
			id="detailsButton"
			(click)="viewIconClickedEvent.next(); $event.stopPropagation()"
			[attr.data-test]="(milestone! | milestoneTypes) + '-details-button' | lowercase"
		>
			<app-icon class="icon material-icons-outlined" [lineWidth]="'1.5px'" [name]="'eye'"></app-icon>
		</div>
	</div>
</div>
